<template>
  <div class="vx-col w-5/6 ml-auto mr-auto" v-if="isQueryDone">
    <span>
      <h4 class="mb-5">Credit Note Supplier</h4>
    </span>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Name"
          name="Vendor"
          :value="this.cnSupplier.supplier_name"
          readonly
        />
      </div>
      <div class="vx-col w-1/2">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Code"
          name="Supplier Code"
          :value="this.cnSupplier.supplier_code"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Total Debit"
          name="Total Debit"
          :value="priceFormat(this.cnSupplier.total_debit)"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Total Credit"
          name="Total Credit"
          :value="priceFormat(this.cnSupplier.total_credit)"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Reference"
          name="Reference"
          :value="this.cnSupplier.reference"
          readonly
        />
      </div>
      <!-- <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Due Date"
          name="Due Date"
          :value="dateFormat(purchase.DueDate)"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Payment Term"
          name="Payment Term"
          :value="purchase.PaymentTermName"
          readonly
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Bank Name"
          name="Bank Name"
          :value="
            purchase.BankName +
            ' - ' +
            purchase.AccountNumber +
            ' ' +
            purchase.AccountName
          "
          readonly
        />
      </div> -->
    </div>
    <vs-divider style="width: 100%"><b>Lines</b></vs-divider>
    <div class="vx-row mb-2">
      <table class="table">
        <thead style="font-weight: bold">
          <tr>
            <td>Customer Code</td>
            <td>Customer Name</td>
            <td>Coa</td>
            <td>Cost Center</td>
            <td>Debit</td>
            <td>Credit</td>
            <td>Description</td>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in cnSupplierLine">
            <tr v-bind:key="item.ID">
              <td>{{ item.customer_code }}</td>
              <td>{{ item.customer_name }}</td>
              <td>{{ item.chart_of_account_name }}</td>
              <td>{{ item.cost_center_name }}</td>
              <td>{{ priceFormat(item.value_debit) }}</td>
              <td>{{ priceFormat(item.value_credit) }}</td>
              <td>{{ item.description }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <vs-divider style="width: 100%; margin-left: 2%"
      ><b>Payment Bank</b></vs-divider
    >
    <div>
      Paid Value : {{ total_paid }}<br />
      <template v-if="total_unpaid.toString().replace(/,/g, '') >= 0">
        Unpaid Value : {{ total_unpaid }}<br />
      </template>
      <template v-else>
        Unpaid Value : 0<br />
        Overpayment :
        {{
          (total_unpaid.toString().replace(/,/g, "") * -1)
            .toString()
            .replace(/,/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }}<br />
      </template>
    </div>
    <vs-table stripe border description :sst="true" :data="payments">
      <template slot="thead">
        <vs-th>Payment Code</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Bank Name</vs-th>
        <vs-th>Account Number</vs-th>
        <vs-th>Payment Voucher</vs-th>
        <vs-th>Total Paid</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.payment_code }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.type }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.bank_name }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.account_number }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ tr.reference_code }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ priceFormat(tr.total_paid) }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-divider style="width: 100%"><b>Attachment</b></vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <div class="vx-col sm:w-1/3 w-full">
        <span>File</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <input
            id="fileInput"
            name="file"
            class="w-full inputx"
            type="file"
            ref="file"
            accept=".jpg, .jpeg, .png"
          />
        </div>
      </div>
    </div>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%">
      <div class="vx-col sm:w-1/3 w-full">
        <span></span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-button class="mr-3 mb-2" @click="handleAttachment"
            >Add Attachment</vs-button
          >
        </div>
      </div>
    </div>
    <vs-divider style="width: 100%"><b>List Attachment</b></vs-divider>
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%">
      <table class="vs-table vs-table--tbody-table">
        <template v-for="tr in attachment">
          <tr
            class="tr-values vs-table--tr tr-table-state-null selected"
            v-bind:key="tr.name"
          >
            <td class="td vs-table--td">{{ tr.file_name }}</td>
            <td class="td vs-table--td">
              <vx-tooltip text="Show" v-if="tr.path != ''">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  @click.stop="downloadFileAwsS3(tr.path)"
                  icon="icon-eye"
                />
              </vx-tooltip>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <vs-divider style="width: 100%"><b>No Vendor Invoice</b></vs-divider>
    <vs-input v-model="selected.VendorInvoiceNumber" class="w-full" />
    <div class="flex mt-6 justify-end w-full" style="width: 100%">
      <vs-button @click="updateVendorInvoiceNumber">Save</vs-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    selected: Object,
  },
  mounted() {
    console.log(this.selected.id, "data");
    this.getData();
  },
  data() {
    return {
      purchase: {},
      lineItem: [],
      charge: [],
      attachment: [],
      dataPaymentProposal: [],
      propose: {},
      notes: "",
      comment: "",
      confirmation: false,
      approveOrReject: 0,
      file: null,
      payments: [],
      total_paid: "",
      total_unpaid: "",
      isQueryDone: false,
      cnSupplier: null,
      cnSupplierLine: null,
    };
  },
  computed: {
    supplier() {
      return this.purchase.SupplierCode + " " + this.purchase.SupplierName;
    },
  },
  watch: {
    "selected.CreditNoteSupplierID"() {
      this.getData();
    },
  },
  methods: {
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("YYYY-MM-DD");
      }
    },
    handleShowAttachment(selected) {
      console.log(selected);
      if (selected.path != "" && selected.path !== undefined) {
        window.open(selected.path);
      } else if (selected.PathFile != "" && selected.PathFile !== undefined) {
        window.open(selected.PathFile);
      }
    },
    handleDeleteAttachment(index, id) {
      this.deleteFile(id);
      this.attachment = this.attachment.filter((item, i) => i != index);
      // console.log(this.table.file);
    },
    deleteFile(id) {
      this.$vs.loading();
      var form = new FormData();
      form.append("id", id);
      this.$http
        .post("/api/v1/pi/delete-file", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    doApprove() {
      this.approveOrReject = 1;
      this.notes = "";
      this.confirmation = true;
    },
    doReject() {
      this.approveOrReject = 0;
      this.notes = "";
      this.confirmation = true;
    },
    closeConfirmation() {
      this.confirmation = false;
    },
    doSubmit() {
      this.$vs.loading();
      const params = {
        status: this.approveOrReject,
        propose_id: this.propose.ID,
        purchase_invoice_id: this.propose.PurchaseInvoiceID,
      };

      this.$http
        .post("/api/v1/purchase-payment-proposal/change-status", params)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "error catch",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log(e);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    handleAttachment() {
      console.log(this.$refs.file.files[0]);
      if (this.$refs.file.files[0]) {
        // this.table.file.push({
        //   name: this.$refs.file.files[0].name,
        //   file: this.$refs.file.files[0],
        //   isNew: true,
        //   path: "",
        // });
        this.file = this.$refs.file.files[0];
        document.querySelector("#fileInput").value = "";
        this.uploadData();
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please select file to import.",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }
    },
    paramUpload() {
      var form = new FormData();
      form.append("pi_id", this.propose.PurchaseInvoiceID);
      form.append("file", this.file);
      return form;
    },
    uploadData() {
      this.$vs.loading();
      this.$http
        .post("/api/v1/pi/upload-file", this.paramUpload(), {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.attachment.push({
            ID: resp.data.attachment.ID,
            NameFile: resp.data.attachment.NameFile,
            PathFile: resp.data.attachment.PathFile,
          });
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(
          "/api/v1/purchase-payment-proposal/credit-note-supplier/" +
            this.selected.CreditNoteSupplierID
        )
        .then((r) => {
          this.$vs.loading.close();
          if (r.code <= 299) {
            this.cnSupplier = r.data.credit_note_supplier;
            this.cnSupplierLine = r.data.line;
            this.payments = r.data.payment;
            // this.purchase = r.data.purchaseInvoice;
            // // console.log("purchase", this.purchase);
            // this.lineItem = r.data.linePurchaseInvoice;
            // this.charge = r.data.charge;
            this.attachment = r.data.attachments;
            // this.propose = r.data.purchasePaymentProposal;
            // this.dataPaymentProposal.push(r.data.purchasePaymentProposal);
            // console.log("proposal", this.dataPaymentProposal);
            // this.comment = this.purchase.CommentInvoice;
            // this.payments = r.data.data_payment;
            this.total_paid = this.priceFormat(r.data.paid);
            this.total_unpaid = this.priceFormat(r.data.unpaid_value);
            this.isQueryDone = true;
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          console.log(e);
        });
    },
    updateVendorInvoiceNumber() {
      this.$vs.loading();
      this.$http
        .put("/api/v1/purchase-payment-proposal/vendor-invoice-number", {
          id: this.selected.ID,
          vendor_invoice_number: this.selected.VendorInvoiceNumber,
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.getData();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "error catch",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-x-circle",
          });
          console.log(e);
        });
    },
  },
};
</script>
<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}
</style>
